import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// Answers are only sent when the participant presses Next, so a questionnaire is
// never reloaded automatically.
const NEVER_RELOAD_ROUTES = [/^\/[^/]+\/resonance\/sequences\/[^/]+\/components\/[^/]+\/?$/];

// Screens that hold nothing the participant is working on: apply a new version at once.
const RELOAD_NOW_ROUTES = [
  /^\/[^/]+\/resonance\/?$/,
  /^\/[^/]+\/resonance\/(sequences|calendar|gift)\/?$/,
  /^\/[^/]+\/resonance\/sequences\/[^/]+\/finished\/?$/,
];

// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
  // Anywhere else (sign-up, login, profile, invitations) the reload waits until the
  // participant stops tapping; screens holding a half-filled form hold it off for
  // longer themselves (see HomeContent and LoguedHome).
  reloadPolicy: () => {
    const path = window.location.pathname;
    if (NEVER_RELOAD_ROUTES.some((route) => route.test(path))) return 'never';
    return RELOAD_NOW_ROUTES.some((route) => route.test(path)) ? 'now' : 'when-idle';
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
